import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCompanyUserDetailList(params) {
  return request({
    url: URL.partner.companyUserDetail,
    method: 'get',
    params
  })
}

export function saveCompanyUser(data) {
  return request({
    url: URL.partner.companyUser,
    method: data.uuid || (data.uuidList && data.uuidList.length > 0) ? 'put' : 'post',
    data
  })
}

export function deleteByUuids(data) {
  return request({
    url: URL.partner.deleteByUuids,
    method: 'delete',
    data
  })
}

export function searchUserForSales(params) {
  return request({
    url: URL.partner.searchUserForSales,
    method: 'GET',
    params
  })
}

export function updateUser(data) {
  return request({
    url: URL.partner.updateUser,
    method: 'Put',
    data
  })
}

export function getByCompanyUuid(params) {
  return request({
    url: URL.partner.getByCompanyUuid,
    method: 'GET',
    params
  })
}

export function batchAddUser(data) {
  return request({
    url: URL.partner.batchAddUser,
    method: 'POST',
    data
  })
}
